
import React, { Component } from 'react';

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectionsOpened: false,
    };
  }

  toggleShowSelectionDropdown = () => {
    this.setState({
      showSelectionsOpened: !this.state.showSelectionsOpened,
    });
  };

  render() {
    return (
      <div
        className={`filter__field-input d-flex align-items-center hasDropdown ${this.state.showSelectionsOpened && 'open'}`}
        onClick={this.toggleShowSelectionDropdown}
      >
        <span className="filter__field-input-caret" />
        <span className="m-l-5">{this.props.selectedItem[this.props.index]?.label}</span>
        <div className="filter__field-input-list">
          {this.props.field.dropdown.map((d) => (
            <div
              key={d.id}
              className={`filter__field-input-list-item ${this.props.selectedItem[this.props.index]?.id === d.id && 'active'}`}
              onClick={this.props.changeFilter.bind(
                this, d.label, this.props.field, this.props.index,
              )}
            >
              {d.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
